import { Component, type ErrorInfo, type ReactNode } from "react";
import { recordBrowserLog } from "../debug/browserLogs";
import { isDynamicImportLoadError, recoverAppResources } from "../services/appResourceRecovery";

interface State { error: Error | null; info: ErrorInfo | null; details: boolean; recovering: boolean; }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, info: null, details: false, recovering: false };
  static getDerivedStateFromError(error: Error): Partial<State> { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { this.setState({ info }); recordBrowserLog("error", error, info.componentStack); }
  private home = () => {
    window.dispatchEvent(new CustomEvent("mh-rp:return-home"));
    this.setState({ error: null, info: null, details: false, recovering: false });
  };
  private refresh = () => {
    if (!isDynamicImportLoadError(this.state.error)) { window.location.reload(); return; }
    this.setState({ recovering: true });
    void recoverAppResources().catch((error) => { recordBrowserLog("error", error); this.setState({ recovering: false }); });
  };
  render() {
    const { error, info, details, recovering } = this.state;
    if (!error) return this.props.children;
    const resource = isDynamicImportLoadError(error);
    return <main className="error-boundary" role="alert">
      <section>
        <span className="eyebrow">猎人手记恢复</span>
        <h1>{resource ? "游戏资源加载失败" : "面板出错了"}</h1>
        <p>{resource ? "浏览器没有取得当前版本的资源。本地存档不会因此被删除。" : "应用遇到了未预期错误；存档不会被自动清除。"}</p>
        <pre>{error.message}</pre>
        <div className="button-row"><button className="primary" disabled={recovering} onClick={this.refresh}>{recovering ? "正在重新加载……" : resource ? "重新加载资源" : "刷新页面"}</button><button onClick={this.home}>返回主菜单</button><button onClick={() => this.setState({ details: !details })}>{details ? "隐藏详情" : "显示详情"}</button></div>
        {details && <pre className="error-details">{error.stack}{info?.componentStack}</pre>}
      </section>
    </main>;
  }
}
